import { render, staticRenderFns } from "./DialogH5.vue?vue&type=template&id=01947b3a&scoped=true"
import script from "./DialogH5.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogH5.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DialogH5.vue?vue&type=style&index=0&id=01947b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01947b3a",
  null
  
)

export default component.exports